import React from "react";
import styles from "components/page-not-found.scss";

export const PageNotFound = () => (
  <div className={ styles.container }>
    <h1 className={ styles.title }>Page Not Found</h1>
    <a href="/">Go to homepage</a>
  </div>
);



// WEBPACK FOOTER //
// ./src/js/components/page-not-found.jsx